import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getRefundModalities} from '../services/getRefundModalities';

export const useGetRefundModalitiesQuery = () =>
	useQuery({
		queryKey: [QUERY_KEYS.REFUND_MODALITIES],
		queryFn: ({signal}) => getRefundModalities(signal),
	});
